/* src/app/views/contract-signature/contract-signature.component.scss */
body .ui-corner-all {
  border-radius: 5px;
}
.margin-top-5 {
  margin-top: 5%;
}
.label-name-car {
  color: #2861A4;
  font-weight: bold;
  font-style: normal;
}
.client-data-title {
  font-weight: normal;
  font-style: normal;
  font-size: 36px;
  line-height: 50px;
  color: #000000;
  padding: 2%;
}
.client-data-field-name {
  font-weight: bold;
  font-style: normal;
  font-size: 20px;
  color: #000000;
}
.client-data-field-sub-name {
  font-weight: bold;
  font-style: normal;
  font-size: 16px;
  color: #000000;
}
.client-data-field-sub-name-14 {
  font-weight: normal;
  font-style: normal;
  font-size: 14px;
  color: #000000;
}
.client-data-field-text {
  font-weight: normal;
  font-style: normal;
  font-size: 18px;
  color: #000000;
  text-align: justify;
  text-justify: inter-word;
}
.client-data-field-sub-text {
  font-weight: normal;
  font-style: normal;
  font-size: 12px;
  color: #000000;
  text-align: justify;
}
.client-data-apply_margin_bottom {
  margin-bottom: 3%;
}
.client-data-message {
  display: grid;
  margin-top: 4px;
}
form {
  border-radius: unset;
  padding: unset;
  box-shadow: unset;
}
.legal-main-card {
  background: #ffffff;
  border: 1px solid #d8e0eb;
  border-radius: 14px;
  box-shadow: 0 10px 24px rgba(16, 43, 78, 0.08);
  overflow: hidden;
  padding: 12px 0 16px;
  margin: 0 auto 24px;
  width: 100%;
  box-sizing: border-box;
}
.margin-line {
  margin-bottom: 15px;
}
.contract-error-message {
  display: block;
  text-align: center;
}
:host ::ng-deep .client-data-message {
  display: block;
  margin-top: 8px;
  margin-bottom: 4px;
  max-width: 100%;
}
:host ::ng-deep .client-data-message .ui-message,
:host ::ng-deep .client-data-message .p-inline-message,
:host ::ng-deep .client-data-message .p-message,
:host ::ng-deep .client-data-message.p-message,
:host ::ng-deep .client-data-message.p-inline-message {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  width: auto;
  max-width: 100%;
  padding: 14px 18px;
  border-radius: 10px;
  border: 1px solid #f5c2c7;
  background: #f8d7da;
  color: #ff4d4f;
  box-sizing: border-box;
}
:host ::ng-deep .client-data-message .ui-message .ui-message-text,
:host ::ng-deep .client-data-message .p-inline-message .p-inline-message-text,
:host ::ng-deep .client-data-message .p-message .p-message-text {
  color: #ff4d4f;
  font-size: 16px;
  line-height: 1.3;
  font-weight: 400;
}
:host ::ng-deep .client-data-message .ui-message .ui-message-icon,
:host ::ng-deep .client-data-message .p-inline-message .p-inline-message-icon,
:host ::ng-deep .client-data-message .p-message .p-message-icon {
  color: #ff4d4f;
  font-size: 22px;
}
.signature-box-table,
.signature-box-container {
  border: 0;
  width: 600px;
  max-width: 100%;
  padding: 0;
  margin: 0;
  box-shadow: none;
  outline: none;
}
.signature-box-table {
  border-collapse: collapse;
  border-spacing: 0;
}
.signature-box-table td {
  border: 0;
  padding: 0;
}
.button-position {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  width: calc(100% - 56px);
  margin: 20px 28px 0;
  padding-top: 18px;
  border-top: 1px solid #d9d9d9;
  box-sizing: border-box;
}
.signature-consent-section {
  width: calc(100% - 56px);
  max-width: none;
  margin: 32px 28px 0;
  padding: 0;
  background: transparent;
  border: 0;
  border-radius: 0;
  box-shadow: none;
  display: grid;
  gap: 0;
}
.consent-card,
.signature-meta-card,
.signature-panel {
  background: transparent;
  border: 0;
  border-radius: 0;
  box-shadow: none;
  box-sizing: border-box;
}
.consent-card {
  padding: 0 0 18px;
}
.consent-check {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  line-height: 1.5;
  transition:
    box-shadow 180ms ease,
    background-color 180ms ease,
    border-color 180ms ease;
  border-radius: 10px;
  padding: 6px 8px;
  margin-left: -8px;
}
.consent-check.terms-focus-active {
  background: #eef6ff;
  box-shadow: 0 0 0 3px rgba(4, 108, 234, 0.2);
}
:host ::ng-deep .consent-check.terms-focus-active .p-checkbox .p-checkbox-box {
  border-color: #046cea !important;
  box-shadow: 0 0 0 3px rgba(4, 108, 234, 0.2) !important;
}
.consent-label {
  font-size: 16px;
  font-weight: 600;
  color: #111827;
  cursor: pointer;
  padding-top: 2px;
}
.signature-meta-card {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 18px 0;
  align-items: center;
  border-top: 1px solid #e8eef6;
}
.signature-meta-label {
  font-size: 15px;
  font-weight: 700;
  color: #00095b;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.signature-meta-value {
  font-size: 15px;
  font-weight: 500;
  color: #1f2937;
  line-height: 1.5;
}
.signature-panel {
  padding: 18px 0 0;
  background: transparent;
  border-top: 1px solid #e8eef6;
}
.signature-panel-header {
  margin-bottom: 14px;
  padding-bottom: 0;
  border-bottom: 0;
}
.signature-panel-title {
  display: block;
  font-size: 16px;
  font-weight: 700;
  color: #00095b;
  line-height: 1.4;
}
.signature-canvas-shell {
  width: 100%;
  padding: 4px;
  border: 1px solid #d7e1ef;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: none;
  transition: all 200ms ease;
}
.signature-canvas-shell:focus-within {
  border: 2px solid #046cea;
  background: #f8fbff;
  box-shadow: 0 2px 8px rgba(4, 108, 234, 0.12), inset 0 1px 2px rgba(15, 23, 42, 0.08);
}
.signature-canvas-shell.is-drawing {
  border: 2px solid #046cea;
  background: #f0f7ff;
  box-shadow: 0 0 0 3px rgba(4, 108, 234, 0.18), inset 0 1px 3px rgba(15, 23, 42, 0.1);
}
.signature-canvas-shell.has-error {
  border: 2px solid #dc2626;
  background: #fff5f5;
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.15);
  animation: shake 0.35s ease;
}
@keyframes shake {
  0%, 100% {
    transform: translateX(0);
  }
  20% {
    transform: translateX(-5px);
  }
  40% {
    transform: translateX(5px);
  }
  60% {
    transform: translateX(-4px);
  }
  80% {
    transform: translateX(4px);
  }
}
:host ::ng-deep .consent-check .p-checkbox,
:host ::ng-deep .consent-check .ui-chkbox {
  margin-top: 2px;
  flex: 0 0 auto;
}
.action-button {
  width: 137px;
  height: 48px;
  background: #046cea;
  border: 1px solid #046cea;
  border-radius: 10px;
  margin-top: 0;
  margin-right: 0;
}
.action-button-label {
  font-size: 15pt;
  font-weight: 500;
  color: #ffffff;
}
.action-button:disabled {
  background-color: #e5e5e5;
  cursor: not-allowed;
  border: 1px solid #aaaaaa;
  opacity: 0.7;
}
.action-button:disabled .action-button-label {
  color: #202020;
}
.action-button:hover:not(:disabled) {
  background: #044ea7;
}
.action-button:disabled:hover {
  background-color: #e5e5e5;
  color: #202020;
  cursor: not-allowed;
  border: 1px solid #aaaaaa;
}
.action-button:disabled:hover .action-button-label {
  color: #202020;
}
.undo-action-button {
  width: 250px;
  height: 48px;
  background: #ffffff;
  border: 1px solid #046cea;
  border-radius: 10px;
  margin-top: 0;
  margin-right: 0;
}
.undo-action-button-label {
  font-size: 15pt;
  font-weight: 500;
  color: #046cea;
  margin-left: 5px;
}
.undo-action-button:hover {
  background: #044ea7;
}
button.undo-action-button:hover .undo-action-button-label {
  color: #ffffff;
}
.button-position-download {
  display: flex;
  flex-wrap: wrap;
  justify-content: right;
  align-items: center;
  margin-top: 28px;
}
.btn-download {
  width: min(400px, 100%);
  height: 48px;
  padding: 0 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: #046cea;
  border: 1px solid #046cea;
  border-radius: 10px;
  margin-top: 20px;
  margin-right: 50px;
  color: #ffffff;
}
.btn-download-label {
  font-size: 15pt;
  font-weight: 500;
  color: #ffffff;
  white-space: nowrap;
}
.btn-download:disabled {
  background-color: #f5f5f5;
  border-color: #aaaaaa;
  color: #6f6f6f;
  cursor: not-allowed;
  opacity: 1;
}
.btn-download:disabled .btn-download-label,
.btn-download:disabled i {
  color: #6f6f6f;
}
.btn-download.is-loading {
  background-color: #f5f5f5;
  border-color: #aaaaaa;
  color: #6f6f6f;
}
.btn-download .pi {
  font-size: 18px;
  color: inherit;
}
.btn-download:hover:not(:disabled) {
  background: #044ea7;
}
@media (max-width: 1200px) {
  .client-data-title {
    font-size: 28px;
    line-height: 38px;
    padding: 3%;
  }
  .client-data-field-name {
    font-size: 18px;
  }
  .client-data-field-sub-name {
    font-size: 15px;
  }
  .client-data-field-sub-name-14 {
    font-size: 13px;
  }
  .client-data-field-text {
    font-size: 16px;
  }
  .client-data-field-sub-text {
    font-size: 11px;
  }
  .action-button {
    width: 120px;
    height: 44px;
  }
  .undo-action-button {
    width: 200px;
    height: 44px;
  }
}
@media (max-width: 768px) {
  .client-data-title {
    font-size: 22px;
    line-height: 30px;
    padding: 4%;
  }
  .client-data-field-name {
    font-size: 16px;
  }
  .client-data-field-sub-name {
    font-size: 13px;
  }
  .client-data-field-sub-name-14 {
    font-size: 12px;
  }
  .client-data-field-text {
    font-size: 14px;
  }
  .client-data-field-sub-text {
    font-size: 10px;
  }
  .signature-consent-section {
    width: calc(100% - 32px);
    margin: 24px 16px 0;
    padding: 0;
  }
  .consent-card,
  .signature-meta-card,
  .signature-panel {
    padding-left: 0;
    padding-right: 0;
  }
  .consent-label,
  .signature-panel-title {
    font-size: 16px;
  }
  .signature-meta-label,
  .signature-meta-value {
    font-size: 15px;
  }
  .button-position {
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 10px;
    width: calc(100% - 32px);
    margin: 16px 16px 0;
    padding-top: 14px;
    padding-bottom: 0;
  }
  .action-button {
    width: 100px;
    height: 40px;
    margin-top: 10px;
  }
  .undo-action-button {
    width: 150px;
    height: 40px;
    margin-top: 10px;
  }
}
@media (max-width: 480px) {
  .client-data-title {
    font-size: 16px;
    line-height: 22px;
    padding: 5%;
  }
  .client-data-field-name {
    font-size: 13px;
  }
  .client-data-field-sub-name {
    font-size: 11px;
  }
  .client-data-field-sub-name-14 {
    font-size: 10px;
  }
  .client-data-field-text {
    font-size: 12px;
  }
  .client-data-field-sub-text {
    font-size: 9px;
  }
  .signature-consent-section {
    width: calc(100% - 24px);
    margin: 20px 12px 0;
    padding: 0;
  }
  .consent-check {
    gap: 10px;
  }
  .consent-label,
  .signature-panel-title,
  .signature-meta-label,
  .signature-meta-value {
    font-size: 14px;
  }
  .button-position {
    flex-direction: column;
    align-items: flex-end;
    gap: 8px;
    width: calc(100% - 32px);
    margin: 14px 16px 0;
    padding-top: 12px;
    padding-bottom: 0;
  }
  .action-button,
  .undo-action-button {
    width: 100%;
    margin-top: 8px;
  }
  .btn-download {
    width: 100%;
    margin-right: 0;
  }
}
.action-button,
.undo-action-button {
  min-width: 90px;
  min-height: 36px;
  box-sizing: border-box;
}
/*# sourceMappingURL=contract-signature.component-ZNG4KXGW.css.map */
